
import React from "react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";

interface FolderHandlersProps {
  user: any;
  projectId: string | null;
  onFolderCreated: () => void;
}

export const useFolderHandlers = ({ user, projectId, onFolderCreated }: FolderHandlersProps) => {
  const handleCreateFolderSubmit = async (folderName: string) => {
    if (!folderName.trim()) {
      toast.error("Vänligen ange ett mappnamn");
      return false;
    }

    if (!user || !projectId) {
      toast.error("Du måste vara inloggad och ha ett projekt valt för att skapa mappar");
      return false;
    }

    try {
      console.log("Creating folder:", { folderName, projectId });
      
      // Create folder directly via Supabase
      const { data: folder, error } = await supabase
        .from('folders')
        .insert({
          name: folderName.trim(),
          project_id: projectId,
          created_by: user.id
        })
        .select()
        .single();

      if (error) {
        console.error("Error creating folder:", error);
        throw error;
      }

      console.log("Folder created successfully:", folder);
      
      // Refresh folder tree to show new folder
      onFolderCreated();
      
      toast.success(`Mapp "${folderName}" har skapats!`);
      return true;
      
    } catch (error: any) {
      console.error("Error creating folder:", error);
      toast.error("Kunde inte skapa mappen", {
        description: error.message || "Ett oväntat fel uppstod"
      });
      return false;
    }
  };

  return { handleCreateFolderSubmit };
};
